export const REST_LIMITED_EMAIL_TEMPLATE = {
  to: 'support@restprofessional.com.au',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - REST Integration',
  body: `Hello REST Support

Could you please enable Snug as an upload destination for our agency for the REST Account(s):

- [Enter your Agency ID here]

Please note: This is a limited integration.

Please assign the REST Agency ID and provide it to us.

Thank you,

Head of Property Management`,
}
